export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20streaming%20platform%20brand%20visual%20with%20warm%20dark%20aesthetic%2C%20elegant%20movie%20theater%20interior%20with%20soft%20gold%20and%20coral%20ambient%20lighting%2C%20luxurious%20velvet%20seats%2C%20professional%20entertainment%20atmosphere%2C%20rich%20deep%20colors%2C%20sophisticated%20design&width=800&height=600&seq=about-platform&orientation=landscape"
                alt="黄瓜影院平台介绍"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full border border-primary-500/20 mb-3">
              关于我们
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide mb-4">
              关于黄瓜影院
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
              黄瓜影院成立于2020年，是一家专注于高清影视在线观看的综合平台。我们以"让每个人都能畅享高清影视"为使命，持续收录全网优质影视资源，为用户提供流畅不缓冲的观影体验。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
              平台目前汇聚超过2.8万部影视资源，涵盖电视剧、电影、综艺、动漫、纪录片等多种类型。通过智能推荐算法和高效的视频加速技术，我们致力于让每一次观影都简单、快捷、愉悦。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              无论是热门电视剧全集的追剧党，还是寻找最新电影大全的影迷，黄瓜影院都是您值得信赖的高清影视平台。我们每日更新最新剧集，保持片库的鲜活与丰富，让好内容触手可及。
            </p>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-check-line text-primary-400"></i>
                </div>
                <span className="text-sm text-foreground-600">正版内容合作</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/10">
                  <i className="ri-check-line text-accent-400"></i>
                </div>
                <span className="text-sm text-foreground-600">7×24小时服务</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-check-line text-primary-400"></i>
                </div>
                <span className="text-sm text-foreground-600">数据安全保障</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}